module.exports = __webpack_public_path__ + "img/kanxi-bg.eae6c32a.jpg";